import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Header,
  Modal,
} from 'semantic-ui-react';

export default class CreditCheckInfoModal extends Component {
  static propTypes = {
    header: PropTypes.string,
    open: PropTypes.bool,
  }
  static getPropsToState = (props) => {
    const open = props.open;
    return {
      open,
    };
  }
  constructor(props) {
    super(props);
    const state = CreditCheckInfoModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = CreditCheckInfoModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  close(callback) {
    this.setState({
      open: false,
    }, () => {
      if (callback) {
        callback();
      }
    });
  }
  handleOnClose = () => {
    this.close();
  }
  render() {
    return (
      <Modal
        open={this.state.open}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="mini"
      >
        <Header as="h4" content={this.props.header} style={{ background: '#F4F5F7' }} />
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                {
                  this.props.header === 'DSR' ? (
                    <p>
                      Debt Service Ratio (DSR) is one of the key parameters used by financial institutions to determine the capacity of a potential borrower to take on a new mortgage after taking into account his/her other existing debts. Typically your DSR should not go beyond 70% after including the mortgage you are applying for.
                    </p>
                  ) : null
                }
                {
                  this.props.header === 'CTOS' ? (
                    <a href="https://www.ctoscredit.com.my/" target="_blank">https://www.ctoscredit.com.my/</a>
                  ) : null
                }
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column>
                <div className="ctosDsrModalButton">
                  <Button onClick={this.handleOnClose} content="Okay" />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CreditCheckInfoModal.jsx